<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h1 class="title">
              {{title}}
            </h1>
            
            <br>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main">
      <div class="section section-text pb-0">
        
        <div class="container" v-if="loaded">  
          <!-- <h4><b>By {{blogData.author}}</b></h4> -->
          <br/> 
        <div v-html="blogData.content"/>
        </div>  
      </div>
      <!-- Author info, sharing has been disabled in v-if -->
      <div class="section section-blog-info" v-if="null">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <div class="md-layout">
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <div class="blog-tags">
                    Tags:
                    <badge
                      type="primary"
                      class="badge-pill"
                    >
                      Photography
                    </badge>
                    <badge
                      type="primary"
                      class="badge-pill"
                    >
                      Stories
                    </badge>
                    <badge
                      type="primary"
                      class="badge-pill"
                    >
                      Castle
                    </badge>
                  </div>
                </div>
                <div
                  class="md-layout-item md-size-50 md-small-size-100 text-right"
                >
                  <md-button
                    href="javascript:void(0)"
                    class="md-google md-round"
                  >
                    <i class="fab fa-google" /> 232
                  </md-button>
                  <md-button
                    href="javascript:void(0)"
                    class="md-twitter md-round"
                  >
                    <i class="fab fa-twitter" /> 910
                  </md-button>
                  <md-button
                    href="javascript:void(0)"
                    class="md-facebook md-round"
                  >
                    <i class="fab fa-facebook" /> 872
                  </md-button>
                </div>
              </div>
              <hr>
              <profile-card
                flex-direction-row
                card-avatar
                card-plain
                :shadow-normal="false"
                :no-colored-shadow="true"
                :card-image="cardProfile.cardProfile1"
              >
                <template slot="cardContent">
                  <h4 class="card-title">
                    Alec Thompson
                  </h4>
                  <p class="description">
                    I've been trying to figure out the bed design for the master
                    bedroom at our Hidden Hills compound...I like good music
                    from Youtube.
                  </p>
                </template>
                <template slot="cardAction">
                  <md-button class="md-round">
                    Follow
                  </md-button>
                </template>
              </profile-card>
            </div>
          </div>
        </div>
      </div>
      <!-- Comments have been disabled in v-if -->
      <div class="section section-comments" v-if="null">
        <div class="container">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
            <div class="comment-area">
              <h3 class="title text-center">
                3 Comments
              </h3>
              <div class="comment">
                <a
                  class="float-left"
                  href="javascript:void(0)"
                >
                  <div class="avatar">
                    <img
                      class="comment-object"
                      :src="comment3"
                      alt="..."
                    >
                  </div>
                </a>
                <div class="comment-body">
                  <h4 class="comment-heading">
                    Tina Andrew <small>· 7 minutes ago</small>
                  </h4>

                  <p>
                    Chance too good. God level bars. I'm so proud of
                    @LifeOfDesiigner #1 song in the country. Panda! Don't be
                    scared of the truth because we need to restart the human
                    foundation in truth I stand with the most humility. We are
                    so blessed!
                  </p>
                  <p>
                    All praises and blessings to the families of people who
                    never gave up on dreams. Don't forget, You're Awesome!
                  </p>

                  <div class="comment-footer">
                    <md-button
                      href="javascript:void(0)"
                      class="md-danger md-simple"
                    >
                      <md-icon>favorite</md-icon> 243
                    </md-button>
                    <md-button
                      href="javascript:void(0)"
                      class="md-success md-simple"
                    >
                      <md-icon>reply</md-icon> Reply
                      <md-tooltip
                        md-direction="top"
                      >
                        Reply to Comment
                      </md-tooltip>
                    </md-button>
                  </div>
                </div>
              </div>

              <div class="comment">
                <a
                  class="float-left"
                  href="javascript:void(0)"
                >
                  <div class="avatar">
                    <img
                      class="comment-object"
                      alt="Tim Picture"
                      :src="comment1"
                    >
                  </div>
                </a>
                <div class="comment-body">
                  <h4 class="comment-heading">
                    John Camber <small>· Yesterday</small>
                  </h4>
                  <p>
                    Hello guys, nice to have you on the platform! There will be
                    a lot of great stuff coming soon. We will keep you posted
                    for the latest news.
                  </p>
                  <p>Don't forget, You're Awesome!</p>
                  <div class="comment-footer">
                    <md-button
                      href="javascript:void(0)"
                      class=" md-simple"
                    >
                      <md-icon>favorite</md-icon> 25
                    </md-button>
                    <md-button
                      href="javascript:void(0)"
                      class="md-success md-simple"
                    >
                      <md-icon>reply</md-icon> Reply
                      <md-tooltip
                        md-direction="top"
                      >
                        Reply to Comment
                      </md-tooltip>
                    </md-button>
                  </div>
                  <div class="comment">
                    <a
                      class="float-left"
                      href="javascript:void(0)"
                    >
                      <div class="avatar">
                        <img
                          class="comment-object"
                          alt="64x64"
                          :src="comment3"
                        >
                      </div>
                    </a>
                    <div class="comment-body">
                      <h4 class="comment-heading">
                        Tina Andrew <small>· 2 Days Ago</small>
                      </h4>

                      <p>
                        Hello guys, nice to have you on the platform! There will
                        be a lot of great stuff coming soon. We will keep you
                        posted for the latest news.
                      </p>
                      <p>Don't forget, You're Awesome!</p>
                      <div class="comment-footer">
                        <md-button
                          href="javascript:void(0)"
                          class="md-danger md-simple"
                        >
                          <md-icon>favorite</md-icon> 243
                        </md-button>
                        <md-button
                          href="javascript:void(0)"
                          class="md-success md-simple"
                        >
                          <md-icon>reply</md-icon> Reply
                          <md-tooltip
                            md-direction="top"
                          >
                            Reply to Comment
                          </md-tooltip>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="title text-center">
                Post your comment
              </h3>
              <div class="comment comment-post">
                <a
                  class="author float-left"
                  href="javascript:void(0)"
                >
                  <div class="avatar">
                    <img
                      class="comment-object"
                      alt="64x64"
                      :src="comment2"
                    >
                  </div>
                </a>
                <div class="comment-body">
                  <md-field maxlength="5">
                    <label>Write some nice stuff or nothing...</label>
                    <md-textarea v-model="aboutme2" />
                  </md-field>
                  <div class="comment-footer">
                    <md-button
                      href="javascript:void(0)"
                      class="md-success md-round"
                    >
                      Post Comment
                    </md-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Badge, ProfileCard } from "@/components";
import Mixins from "@/plugins/basicMixins";
import firebase from "firebase";


export default {
  components: {
    Badge,
    ProfileCard,
    
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "blog-post",
  data() {
    return {
      title: null,
      id: null,
      blogData: null,
      loaded: false,
      aboutme2: null,
      image: require("@/assets/img/bg5.jpg"),
      comment1: require("@/assets/img/faces/card-profile1-square.jpg"),
      comment2: require("@/assets/img/faces/card-profile6-square.jpg"),
      comment3: require("@/assets/img/faces/card-profile4-square.jpg"),
      blogPost: {
        blogPost1: require("@/assets/img/examples/blog4.jpg"),
        blogPost2: require("@/assets/img/examples/blog3.jpg"),
        blogPost3: require("@/assets/img/examples/blog1.jpg")
      },
      cardProfile: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg")
      },
      cardBlog: {
        cardBlog1: require("@/assets/img/examples/blog6.jpg"),
        cardBlog2: require("@/assets/img/examples/blog8.jpg"),
        cardBlog3: require("@/assets/img/examples/blog7.jpg")
      }
    };
  },
  created() {
    this.id = this.$route.params.id
    this.title = this.$route.params.title.replace(new RegExp("-", "g"), " ")
    const vm = this
    firebase.firestore().collection("blog").doc(this.id).get().then(blog => {
      vm.blogData = blog.data()
      vm.loaded = true
    })
  }
};
</script>

<style lang="scss"></style>
